<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="系统编码" prop="systemNo">
        <a-input
          v-model="form.systemNo"
          placeholder="审核通过后系统自动生成"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权证编号" prop="certificateNumber">
        <a-input
          v-model="form.certificateNumber"
          placeholder="请输入权证编号"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="权证类型" prop="propertyType">
            <a-select
              placeholder="请选择经济类型"
              v-model="form.propertyType"
              :not-found-content="fetching.propertyType ? undefined : null"
              @dropdownVisibleChange="propertyTypeDictionaries"
              :disabled="!isEditable"
            >
              <a-spin
                v-if="fetching.propertyType"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="propertyType in dictionaries.propertyType"
                :key="propertyType.value"
              >
                {{ propertyType.note }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 3"
            label="标签"
            prop="label"
          >
            <a-select
              placeholder="请选择标签"
              v-model="form.label"
              :not-found-content="fetching.label ? undefined : null"
              @dropdownVisibleChange="propertyLabelDictionaries"
              :disabled="!isEditable"
            >
              <a-spin
                v-if="fetching.label"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="label in dictionaries.label"
                :key="label.value"
              >
                {{ label.note }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 2"
            label="使用权证明文件名"
            prop="useRightsFileName"
          >
            <a-input
              v-model="form.useRightsFileName"
              style="width: 100%"
              placeholder="请输入使用权证明文件名"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="权证面积（㎡）"
            prop="certificateArea"
            extra="提示：请填写建筑面积，若无，填写宗地面积。"
          >
            <a-input
              v-model="form.certificateArea"
              style="width: 100%"
              placeholder="请输入权证面积"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 3"
            label="权利证明文件名称"
            prop="rightsCertificateFileName"
          >
            <a-input
              v-model="form.rightsCertificateFileName"
              style="width: 100%"
              placeholder="请输入使用权证明文件名"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <!-- 字典 -->
    <a-col :span="12">
      <a-form-model-item label="权证地址" prop="certificateAddressCode">
        <a-cascader
          v-model="form.certificateAddressCode"
          :options="options.addressCode"
          :load-data="loadData"
          placeholder="请选择权证地址"
          notFoundContent="正在加载..."
          change-on-select
          @popupVisibleChange="areaDictionaries"
          @change="onCertificateAddressChange"
          :disabled="!isEditable"
        >
          <template slot="displayRender" slot-scope="{ labels }">
            {{
              (!selectProvinceType || !(options?.addressCode?.length > 0)) &&
              form?.certificateAddressCode?.length > 0
                ? "上海 / 虹口区 / 曲阳路接到"
                : labels.join(" / ")
            }}
          </template>
        </a-cascader>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权证地址详细地点" prop="certificateAddress">
        <a-input
          v-model="form.certificateAddress"
          placeholder="请输入权证地址详细地点"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24" style="margin-bottom: -10px">
      <a-form-model-item label="实际地址类型" prop="consistentWithCertificate">
        <a-radio-group
          v-model="form.consistentWithCertificate"
          :disabled="!isEditable"
        >
          <a-radio :value="1">与产证地址一致</a-radio>
          <a-radio :value="2">与产证地址不一致</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="实际地址" prop="physicalAddressCode">
            <a-cascader
              v-model="form.physicalAddressCode"
              :options="options.addressCode"
              :load-data="loadData"
              placeholder="请选择实际地址"
              notFoundContent="正在加载..."
              change-on-select
              @popupVisibleChange="areaDictionaries"
              :disabled="!isEditable || isAddressSame"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="实际地址详细地点" prop="physicalAddress">
            <a-input
              v-model="form.physicalAddress"
              :disabled="!isEditable || isAddressSame"
              placeholder="请输入实际地址详细地点"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <template v-if="physicalProvinceCode === '310000'">
      <a-col :span="24">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="所属地段" prop="district">
              <a-select
                placeholder="请选择所属地段"
                v-model="form.district"
                :not-found-content="fetching.district ? undefined : null"
                @dropdownVisibleChange="districtDictionaries"
                :disabled="!isEditable"
              >
                <a-spin
                  v-if="fetching.district"
                  slot="notFoundContent"
                  size="small"
                />
                <a-select-option
                  v-else
                  v-for="district in dictionaries.district"
                  :key="district.value"
                >
                  {{ district.note }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="是否涉及以下板块" prop="isCoverBlock">
              <a-radio-group
                v-model="form.isCoverBlock"
                :disabled="!isEditable"
              >
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="form.isCoverBlock == 1">
            <a-form-model-item label="所属板块" prop="block">
              <a-spin v-if="fetching.block" />
              <a-checkbox-group
                v-else
                v-model="form.block"
                style="width: 100%"
                :disabled="!isEditable"
              >
                <a-row :gutter="[0, 12]">
                  <a-col
                    :span="6"
                    v-for="item in dictionaries.block"
                    :key="item.value"
                  >
                    <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>
    </template>

    <a-col :span="24">
      <a-form-model-item
        label="权证用途"
        prop="assetUse"
        extra="提示：请填写房屋用途，若无，填写“/”。"
      >
        <a-input
          v-model="form.assetUse"
          placeholder="请输入权证用途"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
const LEAF_REGIONS = ["台湾省", "香港特别行政区", "澳门特别行政区"];
import {
  getPropertyType,
  getLabel,
  getProvinceList,
  getAreaList,
  getDistrict,
  getBlock,
} from "@/api/shexgrp/Dictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fetching: {
        propertyType: false,
        label: false,
        district: false,
        block: false,
        obligeeType: false,
        economicType: false,
      },
      dictionaries: {
        propertyType: [],
        label: [],
        district: [],
        block: [],
      },
      options: {
        addressCode: [],
      },
      //是否选中一级地址标志位，用于判断是否显示固定地址
      selectProvinceType: false,
    };
  },
  computed: {
    isAddressSame() {
      return this.form.consistentWithCertificate === 1;
    },

    physicalProvinceCode() {
      const val = this.form.physicalAddressCode;
      if (!val) return undefined;

      // Cascader 数组
      if (Array.isArray(val)) {
        return val[0];
      }

      // 逗号字符串
      if (typeof val === "string") {
        return val.split(",")[0];
      }

      return undefined;
    },
  },

  mounted() {},

  watch: {
    "form.consistentWithCertificate": {
      immediate: true,
      handler(val) {
        if (val === 1) {
          // 与权证地址一致 → 自动同步
          this.form.physicalAddressCode = this.form.certificateAddressCode
            ? [...this.form.certificateAddressCode]
            : undefined;

          this.form.physicalAddress = this.form.certificateAddress || undefined;

          // 清除校验错误（非常关键）
          this.$nextTick(() => {
            this.$refs.baseForm?.clearValidate([
              "physicalAddressCode",
              "physicalAddress",
            ]);
          });
        } else {
          // 不一致 → 清空，强制用户重新填写
          this.form.physicalAddressCode = undefined;
          this.form.physicalAddress = undefined;
        }
      },
    },

    // 证件地址变化时，同步更新实际地址（仅在“一致”状态）
    "form.certificateAddressCode"(val) {
      if (this.isAddressSame) {
        this.form.physicalAddressCode = val ? [...val] : undefined;
      }
    },

    "form.certificateAddress"(val) {
      if (this.isAddressSame) {
        this.form.physicalAddress = val;
      }
    },

    "form.isCoverBlock"(val) {
      if (val == 1) {
        this.blockDictionaries();
      }
    },
  },

  methods: {
    // 用户“选中一级地址”时触发
    onCertificateAddressChange() {
      this.selectProvinceType = true;
    },

    //权证类型字典
    propertyTypeDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.propertyType.length > 0) return;
      //获取字典内容
      this.fetching.propertyType = true;
      getPropertyType()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.propertyType = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.propertyType = false;
        });
    },
    //权证类型其他-标签字典
    propertyLabelDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.label.length > 0) return;
      //获取字典内容
      this.fetching.label = true;
      getLabel()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.label = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.label = false;
        });
    },

    //所属地段字典
    districtDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.district.length > 0) return;
      //获取字典内容
      this.fetching.district = true;
      getDistrict()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.district = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.district = false;
        });
    },

    //所属板块字典
    blockDictionaries() {
      // 已有数据则不再请求
      if (this.dictionaries.block.length > 0) return;
      //获取字典内容
      this.fetching.block = true;
      getBlock()
        .then((res) => {
          if (res && res.code === "200") {
            const list = res.data || [];
            this.dictionaries.block = this.sortBlockList(list);
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.block = false;
        });
    },

    //便利性优化排序地点
    sortBlockList(list) {
      // 置顶板块
      const TOP_SET = new Set(["南北转型板块(宝山、金山)"]);

      // 置底板块
      const BOTTOM_SET = new Set([
        "五大新城板块(嘉定、青浦、松江、奉贤、南汇，包含吴淞创新城板块)",
      ]);

      return list.slice().sort((a, b) => {
        const aTop = TOP_SET.has(a.note);
        const bTop = TOP_SET.has(b.note);
        if (aTop && !bTop) return -1;
        if (!aTop && bTop) return 1;

        const aBottom = BOTTOM_SET.has(a.note);
        const bBottom = BOTTOM_SET.has(b.note);
        if (aBottom && !bBottom) return 1;
        if (!aBottom && bBottom) return -1;

        // 其余保持原顺序（或后续可加二级排序）
        return 0;
      });
    },

    //获取省份列表
    async areaDictionaries(visible) {
      if (!visible) return;

      // ✅ 已经有省份数据，直接返回（防止重复请求）
      if (this.options.addressCode.length > 0) return;

      try {
        const res = await getProvinceList();
        if (res?.code === "200") {
          setTimeout(() => {
            this.options.addressCode = (res.data || []).map((item) => ({
              label: item.XZQYMC,
              value: item.XZQYDM,
              isLeaf: LEAF_REGIONS.includes(item.XZQYMC),
            }));
            this.options.addressCode = this.sortAreaList(
              this.options.addressCode
            );
          }, 300);
        }
      } catch (e) {
        console.error("省份列表加载失败", e);
      }
    },

    //便利性优化排序地点
    sortAreaList(list) {
      const CURRENCY_PRIORITY = {
        北京: 1,
        上海: 2,
      };

      return list.slice().sort((a, b) => {
        const pa = CURRENCY_PRIORITY[a.label] || 999;
        const pb = CURRENCY_PRIORITY[b.label] || 999;
        return pa - pb;
      });
    },

    //更新新地区列表信息
    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      // 开启当前节点 loading（自动显示 Spin）
      targetOption.loading = true;

      try {
        const res = await getAreaList({
          sjxzqydm: targetOption.value,
        });

        if (res?.code === "200") {
          targetOption.children = (res.data || []).map((item) => ({
            label: item.XZQYMC,
            value: item.XZQYDM,
            isLeaf: selectedOptions.length >= 2, // 后端返回是否还有下级
          }));
          this.options.addressCode = [...this.options.addressCode];
        }
      } catch (e) {
        console.error("级联地址加载失败", e);
      } finally {
        // 关闭 loading
        targetOption.loading = false;
      }
    },
  },
};
</script>

<style>
</style>